/**
 * Capability detail page -- /twin/capability/:id (P2.7.e).
 * Thin wrapper around EntityDetailLayout. v0.2.0 ships null chips
 * (backlog #435 -- per-entity chip aggregator). For now, the
 * capability map's CellDrawer is the chip-rich surface for
 * capability state.
 */
import { useParams } from "react-router-dom";

import { EntityDetailLayout } from "twin/entity/EntityDetailLayout";

const NULL_CHIPS = {
  resilience: null,
  blast_ibs_count: null,
  process_count: null,
  obligation_count: null,
} as const;

export function CapabilityDetail() {
  const { id } = useParams<{ id: string }>();
  return <EntityDetailLayout kind="capability" entityId={id} chips={NULL_CHIPS} />;
}
